import React, {useEffect, useState} from 'react';
import moment from "moment-timezone";
import {useDispatch, useSelector} from 'react-redux';
import * as action from '../actions';
import Home from '../assets/SVG/buttons/Home-button-big.svg';
import Profile from '../assets/SVG/icons/Avatar.svg';
import Logout from '../assets/SVG/buttons/logout.svg';
import axios from 'axios';
import lodash from 'lodash';
import config from '../config';
import '../styles/navigation.css';
import {getAffiliateAcById} from '../api';
import {useHistory} from "react-router-dom";
import useTitle from "../hooks/useTitle";

axios.defaults.withCredentials = true;

export default function Navigation(props) {
  useTitle("Menu")
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(state => state.user);
  const [affiliateProducts, setAffiliateProducts] = useState([])
  const [showAccountSubMenu, setShowAccountSubMenu] = useState(false);
  const [hasRevenueCatSubscription] = useState(user?.hasRevenueCatSub);

  useEffect(async () => {
    if (user?.affiliateLinkId) {
      const getAffiliateAcByAffLinkIdResp = await getAffiliateAcById(user.affiliateLinkId);
      setAffiliateProducts(getAffiliateAcByAffLinkIdResp.products)
    }
  }, []);


  const handleLogout = () => {
    axios.get(config.backend_url + '/logout')
      .then(function (response) {
        history.push('/login');
        dispatch(action.logoutUser());
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const showAccountSubMenuHandle = () => {
    setShowAccountSubMenu(!showAccountSubMenu)
  }

  const showPlanForAffiliate = () => {
    console.log('showPlanForAffiliate::', user?.affiliateLinkId)
    if (!user?.affiliateLinkId) return true;
    if (
      user.affiliateLinkId &&
      (user.accountType === "trial_expired" || user.accountType === "trial") &&
      lodash.isEmpty(affiliateProducts)
    ) {
      return false;
    }
    return true;
  };

  return (
    <div className="container">
      <div className="main navigation" data-testid="navigation">
        <div className="header mt-3">
          <img src={Home} alt="home" onClick={() => history.push("/home")}></img>
          <img
            src={user?.picture ? user.picture : Profile}
            alt="profile"
            className="profile mt-4"
            onClick={() => history.push("/navigation")}
          ></img>
          <img src={Logout} data-testid="logout-btn" alt="logout" onClick={handleLogout}></img>
        </div>
        <p className="text-center mt-3 heading">Preferences</p>
        <div className="wrapper" data-testid="wrapper">
          <div className="card">
            <div id="update-profile" className="card-body" onClick={() => history.push("/update-profile")}>
              Profile
            </div>
          </div>
          {user?.accountType !== "free" && showPlanForAffiliate() && (
            <div className="card-extra">
              <div className="card-body">
                <div data-testid="menu-account-show-link" onClick={showAccountSubMenuHandle}>
                  Account
                </div>
                {showAccountSubMenu && (
                  <div className="sub-menu-account">
                    <div
                      className="sub-menu-account-item"
                      data-testid="sub-menu-account-item-plans"
                      onClick={() => history.push("/plans")}
                    >
                      Plans
                    </div>
                    <div
                      className="sub-menu-account-item"
                      data-testid="sub-menu-account-item-payments"
                      onClick={() => history.push("/payments")}
                    >
                      Payments
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="card">
            <div id="testhistory" className="card-body" onClick={() => history.push("/testhistory")}>
              Test History
            </div>
          </div>
          <div className="card">
            <div id="alerts" className="card-body" onClick={() => history.push("/alerts")}>
              Alerts
            </div>
          </div>          
          <div id="settings" className="card" onClick={() => history.push("/settings")}>
            <div className="card-body">Settings</div>
          </div>
          <div id="privacy-settings" className="card" onClick={() => history.push("/privacy-settings")}>
            <div className="card-body">Privacy Settings</div>
          </div>
        </div>
        {user?.last_visit ? (
          <div className="card-body mt-3">
            <span className="bold">Last Login:</span>{" "}
            <span className="mr-0">
              {moment(user.last_visit)
                .tz(user?.timezone || config.defaultTimezone)
                .format("YYYY-MM-DD hh:mm A")}
            </span>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
